import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoadingState } from './primitives';

/**
 * Guards every authenticated route. Enforces, in order:
 *   1. auth still initializing  -> loading screen
 *   2. not signed in            -> /login
 *   3. signed in but not on the WHITELISTED_IDS allowlist -> /forbidden
 * Only allowlisted, authenticated users reach the portal.
 */
export default function ProtectedRoute() {
  const { user, initializing, isAllowed } = useAuth();

  if (initializing) {
    return (
      <div className="center-screen">
        <LoadingState label="Checking access…" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!isAllowed) return <Navigate to="/forbidden" replace />;

  return <Outlet />;
}
